<div
  [matTooltip]="allTagNames()"
  [matTooltipDisabled]="!isClipped()"
  class="task-table-tags"
>
  @for (tag of visibleTags(); track tag.id) {
    <proffeo-tag [tag]="tag" />
  }
  @if (hiddenCount() > 0) {
    <span class="task-table-tags-more">{{ 'project-tasks.list.more-tags' | translate: { count: hiddenCount() } }}</span>
  }
</div>
<div
  aria-hidden="true"
  class="task-table-tags-measure"
>
  @for (tag of tags(); track tag.id) {
    <proffeo-tag [tag]="tag" />
  }
  <span class="task-table-tags-more">+00</span>
</div>
